export default __webpack_public_path__ + "static/media/player-01@2x.1e580114.webp";